import { updatePublishSelectedCalendar } from '../actions/calendarPublishing';
import getStore from '../store/publishingStore';
import PublishingPermissionItemState from '../store/schema/PublishingPermissionItemState';
import { mutator } from 'satcheljs';

export default mutator(updatePublishSelectedCalendar, msg => {
    let viewState = getStore().viewState;

    let publishingItem: PublishingPermissionItemState = msg.selectedPublishingItemState;

    if (viewState) {
        viewState.selectedPublishingItemState = publishingItem;
        viewState.selectedPublishingPermission = publishingItem
            ? publishingItem.CurrentDetailLevel
            : null;
    }
});
